import React from "react";
import { Container, Row, Col, UncontrolledCollapse } from "reactstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Fade from "react-reveal/Fade";

const questions = [
  {
    question: "Se eu tiver alguma dificuldade em cadastrar um produto, a Pedimos poderá fazer isso por mim?",
    answer:
      "Sim, podemos. Entretanto esse processo poderá levar algumas horas, dependerá da demanda dos nossos colaboradores."
  },
  {
    question: "Preciso mais que 10 qr-codes, posso comprar mais?",
    answer:
      "Sim, o preço unitário de cada adesivo custa R$ 5,00 para o adesivo de vinil e R$ 12,00 para o identifacador em alumínio."
  },
  {
    question: "Um dos qr-codes foi extraviado, como faço para repor?",
    answer:
      "Entre em contato conosco, poderemos enviar um outro identificador, porém com outro código."
  },
  {
    question: "Tem custo para enviar outro qr-code?",
    answer:
      "Se for adquirido mais de 10 identifadores, o frete será grátis, senão terá o custo de 20 reais."
  },
  {
    question: "Por que tem um custo mensal de R$ 19,90?",
    answer:
      "A Pedimos Cardápio Digital oferece um poderoso Dashboard para gerenciar seus produtos. Poderá ser cadastrado as categorias dos produtos, suas descrições e imagens. Todo esse processo ocupa espaço e recursos de segurança no banco de dados. Será disponibilizado um link para divulgar seu cardápio de forma digital, seja nas redes sociais como em ferramentas de comunicação."
  },

];

const Faqs = () => {
  return (
    <section className="section faqs-dd bg-light top-left ">
      <div className="shapes-container">
        <div className="absolute icon">
          <Fade top left>
            <FontAwesomeIcon icon={["fas", "question"]} />
          </Fade>
        </div>
      </div>

      <Container>
        <div className="section-heading text-center">
          <h2 className="heading-line" style={{textAlign:"center"}}>Dúvidas frequentes</h2>
          <p className="lead" style={{textAlign:"center"}}>Veja mais sobre o Cardápio Digtal.</p>
        </div>

        <Row>
          <Col lg="8" className="mx-lg-auto">
            {questions.map((faq, i) => (
              <Fade bottom key={i}>
                <div className="card shadow-box shadow-hover mb-3" key={i}>
                  <div className="card-header py-3">
                    <Link
                      to="#"
                      className="card-title collapsed"
                      id={`toggler-${i}`}
                    >
                      {faq.question}
                    </Link>
                  </div>

                  <UncontrolledCollapse toggler={`#toggler-${i}`}>
                    <div className="card-body">{faq.answer}</div>
                  </UncontrolledCollapse>
                </div>
              </Fade>
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Faqs;
